import type { ReactNode } from 'react';

export type FigureFailureHostMaterialKind = 'worksheet' | 'reading';

type FigureGenerationFailureActionsProps = {
    hostMaterialKind?: FigureFailureHostMaterialKind;
    onOpenRegenerateHostMaterial?: () => void;
    onOpenRegenerateLesson?: () => void;
    className?: string;
};

function LinkButton({
    onClick,
    disabled,
    className,
    children,
}: {
    onClick?: () => void;
    disabled?: boolean;
    className: string;
    children: ReactNode;
}) {
    if (!onClick) return <>{children}</>;
    return (
        <button type="button" className={className} onClick={onClick} disabled={disabled}>
            {children}
        </button>
    );
}

export function FigureGenerationFailureActions({
    hostMaterialKind,
    onOpenRegenerateHostMaterial,
    onOpenRegenerateLesson,
    className = 'text-gray-700',
}: FigureGenerationFailureActionsProps) {
    const linkClassName =
        'font-medium text-action-blue underline hover:text-action-blue-dark disabled:cursor-not-allowed disabled:opacity-50';
    const hostLabel = hostMaterialKind === 'reading' ? 'Reading' : 'Worksheet';

    return (
        <p className={className}>
            Regenerate the{' '}
            <LinkButton onClick={onOpenRegenerateHostMaterial} className={linkClassName}>
                {hostLabel}
            </LinkButton>{' '}
            or the{' '}
            <LinkButton onClick={onOpenRegenerateLesson} className={linkClassName}>
                Lesson
            </LinkButton>{' '}
            for a fresh start.
        </p>
    );
}
